import React, { Fragment, PureComponent } from "react";
import { Link } from "react-router-dom";
import { Card, CardBody, Col, Button, ButtonToolbar, Table } from "reactstrap";

import "./styles.css";
import axios from "axios";
import _ from "lodash";

class PrintBinData extends PureComponent {
  constructor(props) {
    var tempDate = new Date();
    var date =
      tempDate.getFullYear() +
      "-" +
      (tempDate.getMonth() + 1) +
      "-" +
      tempDate.getDate() +
      " " +
      tempDate.getHours() +
      ":" +
      tempDate.getMinutes() +
      ":" +
      tempDate.getSeconds();
    const currDate = date;
    super(props);
    
    this.prinData = this.prinData.bind(this);
    this.state = {
      showPassword: false,
      showPrintData: [],
      date: currDate,
    };
  }

  componentDidMount() {
    var printDetail_data = localStorage.getItem("printBinData");
  
    //this.state.showPrintData.push(sorted_data);

    setTimeout(this.prinData, 1100);
  }

  prinData() {
    window.print();
  }

  render() {
    const { handleSubmit } = this.props;
    const pickType = localStorage.getItem("pickType");
    const arrData = JSON.parse(localStorage.getItem("printBinData"));

    /*var sorted_data = {};
    for (var username in arrData) {
      sorted_data[username] = [];
      arrData[username].map((item) => {
        if (item.lbSkuId != undefined) {
          sorted_data[username].push(item);
        } else {
          sorted_data[username].push(
            item.sort(function (a, b) {
              var textA = a.lbSkuId.toUpperCase();
              var textB = b.lbSkuId.toUpperCase();
              return textA < textB ? -1 : textA > textB ? 1 : 0;
            })
          );
        }
      });
    */
    //const arrayValue = [];
    //arrayValue.push(sorted_data);
    console.log(arrData);
    //console.log(arrayValue);
    //console.log(arrayValue.sort());
    var batch_id = localStorage.getItem("batch-id");
    return (
      <div className="print_table" style={{ padding: 15 }}>			{Object.keys(arrData).map(username =>
            <div style={{ width: "100%" }}>
              <div
                className="separater"
                style={{ marginBottom: 20, borderBottomWidth: 1 }}
              >

                {
                  <Table
                    responsive
                    className="table table--bordered"
                    style={{ marginBottom: 50 }}
                  >
                    <thead
                      className="thead_align"
                      
                    >
					<tr style={{ marginTop: 20, background: "#fff" }}>
                        <th colspan="4" style={{ marginTop: 20 }}>
                          <h5>
                            
                            <span style={{ fontWeight: "bold" }}>
                              
                              User Name:
                            </span>
                            <span>{username}</span>
                          </h5>
                        </th>

                       
                        <th colspan="3" style={{ marginTop: 20 }}>
                        <h5 style={{ textAlign: "center" }}>
                          <span style={{ fontWeight: "bold" }}>
                            Batch ID :
                          </span>
                          <span>
						  {batch_id}
                          </span>
                          
                        </h5>
                      </th> 
                       
                        <th colspan="3" style={{ marginTop: 20 }}>
                          
                          <h5 style={{ textAlign: "right" }}>
                            <span style={{ fontWeight: "bold" }}> Date: </span>{" "}
                            <span>{this.state.date}</span>
                          </h5>
                        </th>
                      </tr>
                      <tr style={{ marginTop: 20, background: "#ccc" }}>
                        <th>LBSKUID</th>
						<th>Product Description</th>
						<th>PKD</th>
						<th>CBU Code</th>
						<th>Zone Name</th>
						<th>From Bin</th>
						<th>To Bin</th>
						<th>ICLD Quantity(Box)</th>
						<th>Total Loose Quantity(pcs)</th>
						<th>Total Quantity(pcs)</th>
                      </tr>
                    </thead>
                    <tbody>
                        <Fragment>
                          {arrData[username].map((value, key) =>(
                            <tr>
                             <td>{value["lb_sku_id"]}</td>							<td>{value["product_desc"]}</td>							<td>{value["pkd"]}</td>							<td>{value["cbucode"]}</td>							<td>{value["zone_name"]}</td>							<td>{value["from_location"]}</td>							<td>{value["to_location"]}</td>							<td>{value["to_be_picked_icld_qty"]}</td>							<td>{value["to_be_picked_loose_qty"]}</td>						    <td>{value["to_be_picked_qty"]}</td> 
                            </tr>
                          ))}
                        </Fragment>
                      
                    </tbody>
                  </Table>
                }
              </div>
              <div className="page-break"> </div>
            </div>
	)}
      </div>
    );
  }
}

export default PrintBinData;